import { ArrowLeftOutlined, ArrowRightOutlined } from '@mui/icons-material'
import { IconButton, Stack, Tooltip } from '@mui/material'
import { observer } from 'mobx-react'
import React, { forwardRef } from 'react'

interface PaginationControlsProps {
  onPageChange: (event: null, page: number) => void
  page: number
  count: number
  rowsPerPage: number
}

const PaginationControls = observer(
  ({ onPageChange, page, count, rowsPerPage }: PaginationControlsProps) => {
    const isPrevDisabled = page === 0
    const isNextDisabled = page >= Math.ceil(count / rowsPerPage) - 1

    return (
      <Stack direction='row' spacing={2} ml={3}>
        <Tooltip title='Вернуться на предыдущую страницу' placement='top'>
          <PaginationButton
            direction='prev'
            disabled={isPrevDisabled}
            onClick={() => onPageChange(null, page - 1)}
          />
        </Tooltip>
        <Tooltip title='Перейти к следующей странице' placement='top'>
          <PaginationButton
            direction='next'
            disabled={isNextDisabled}
            onClick={() => onPageChange(null, page + 1)}
          />
        </Tooltip>
      </Stack>
    )
  },
)

const PaginationButton = forwardRef<
  HTMLButtonElement,
  {
    direction: 'prev' | 'next'
    disabled: boolean
    onClick: () => void
  }
>(({ direction, ...props }, ref) => (
  <IconButton ref={ref} sx={buttonStyle(props.disabled)} {...props}>
    {direction === 'prev' ? (
      <ArrowLeftOutlined sx={iconStyle(props.disabled)} />
    ) : (
      <ArrowRightOutlined sx={iconStyle(props.disabled)} />
    )}
  </IconButton>
))

const buttonStyle = (disabled: boolean) => ({
  backgroundColor: disabled
    ? 'rgba(0, 0, 0, 0.1)!important'
    : 'rgba(93, 175, 239, 0.4)',
  height: '24px',
  width: '24px',
  borderRadius: '50%',
  '&:hover': {
    backgroundColor: 'rgba(93, 175, 239, 0.5)',
  },
})

const iconStyle = (disabled: boolean) => ({
  opacity: disabled ? 0.6 : 1,
  width: '24px',
  height: '24px',
  fill: '#000',
})

export default PaginationControls
